import { type FC, type ReactNode } from "react";

interface Props {
    children: ReactNode;
}

export const NavigationList: FC<Props> = ({ children }) => {
    return (
        <ul className="list-none grow m-0 px-8 pt-8 pb-4">
            {children}
        </ul>
    );
};
